export default __webpack_public_path__ + "static/media/bg2.53ef07e1.png";